import { get } from '@/api/axios';
import { UiConfigEndpoints } from '@/api/endpoints/UiConfigEndpoints';
import { type LoginAppearanceDto } from '@/app/models/LoginAppearanceDto';

export const getDetails = () => get<LoginAppearanceDto>(UiConfigEndpoints.loginAppearance, { timeout: 6000 });
